import { useMemo } from 'react';
import { useCompliance } from '@/components/ComplianceProvider/ComplianceProvider';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { FEATURE_FLAGS } from '@/utils/featureFlags';

export enum USDCRewardsEligibility {
  RETAIL_USDC_REWARDS = 'RETAIL_USDC_REWARDS',
  INSTO_USDC_REWARDS = 'INSTO_USDC_REWARDS',
  NA = 'NA',
}

export function useUSDCRewards() {
  const { isRetailAccount, attestationCountry, isCompliant } = useCompliance();
  const isUSDCRewardsFeatureFlagEnabled = useFeatureFlag(
    FEATURE_FLAGS.NEXT_PUBLIC_FEATURE_FLAG_FRONTEND_USDC_REWARDS,
  );

  return useMemo(() => {
    // Check if user is in US
    const isUSUser = attestationCountry === 'US';

    // Must have feature flag enabled and be US user
    if (!isUSDCRewardsFeatureFlagEnabled || !isUSUser || !isCompliant) {
      return USDCRewardsEligibility.NA;
    }

    return isRetailAccount
      ? USDCRewardsEligibility.RETAIL_USDC_REWARDS
      : USDCRewardsEligibility.INSTO_USDC_REWARDS;
  }, [isRetailAccount, attestationCountry, isUSDCRewardsFeatureFlagEnabled, isCompliant]);
}
